class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    const ghostSampleButtons = document.querySelectorAll('.cart-remove-sample');

    ghostSampleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variant = button.getAttribute('data-variant-id')
        const hiddenSample = document.querySelector(`.cart-items .cart-item.visually-hidden[data-variant='${variant}']`);
        if (hiddenSample) {
          const sampleRemoveButton = hiddenSample.querySelector('cart-remove-button');

          if (sampleRemoveButton) {
            sampleRemoveButton.click();
          }
        }
      });
    })
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-free-samples',
        section: document.getElementById('main-cart-free-samples').dataset.id,
        selector: '.accordion-page--free-samples',
      }
    ];
  }

  checkSamplesCallback() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        freeSampleChecking(data);
      })
      .catch(() => {
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    // Update removed gift items in sessionStorage
    let currentCartItemVariant;
    let isGiftRemoved;
    const currentCartItem = document.getElementById(`CartDrawer-Item-${line}`);

    if (currentCartItem) {
      // Assign gift removed based on attribute & quantity set
      if (quantity == 0 && currentCartItem.dataset.gift === 'true') isGiftRemoved = true;
      // Set current item variant
      currentCartItemVariant = currentCartItem.dataset.variant;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        freeSampleChecking(parsedState);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (elementToReplace.parentElement.classList.contains('accordions--initialized')) {
            elementToReplace.parentElement.classList.remove('accordions--initialized');
            document.dispatchEvent(new Event('cartContentUpdated'));
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // Push to array of removed gifts in sessionStorage
        if (isGiftRemoved) {
          const removedGiftsVal = sessionStorage.getItem('fab_removed_gifts');

          let removedGiftsArr = removedGiftsVal ? JSON.parse(removedGiftsVal) : [];

          removedGiftsArr.push(currentCartItemVariant);
          sessionStorage.setItem('fab_removed_gifts', JSON.stringify(removedGiftsArr));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        initCartPageSplider();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    clearCart();

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      initCartSpliders();
      initCartPageSplider();
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

async function clearCart() {
  const res = await fetch("/cart.js");
  const cartData = await res.json();

  if (cartData.total_price <= 0) {
    const clearRes = await fetch("/cart/clear.js");
    const drawerRes = await fetch('/?section_id-cart-drawer').then(response => response.text()).then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      return doc;
    })
    if (clearRes.ok) {
      const fetchedData = drawerRes.querySelector('cart-drawer');
      document.querySelector('cart-drawer').innerHTML = fetchedData.innerHTML;
      document.querySelector('cart-drawer').classList.add('is-empty');
      document.querySelector('.cart-count-bubble').remove();
    }
  }
}

function initCartPageSplider() {
  const mainCartSlider = document.querySelector('main.main-cart');
  if(mainCartSlider){
    const cart = document.querySelector('.cart-slider');
    
    const initSlider = (carouselSelector, perPage) => {
      const carousel = cart.querySelector(carouselSelector);

      if (!carousel || carousel.classList.contains('is-initialized')) {
        return;
      }

      new Splide(carousel, {
        perPage: perPage,
        loop: false,
        arrows: false,
        gap: 8,
        mediaQuery: 'min',
        rewind: true,
        rewindByDrag: true,
        breakpoints: {
          1024: {
            gap: 24,
          },
        },
      }).mount();
    };

    initSlider('.splide.free-samples', 1);
  }
}

function freeSampleChecking(response) {
  const cartDrawer = document.querySelector('.cart-drawer__inner-container');
  const mainCart = document.querySelector('main.main-cart');

  if (cartDrawer) {
    const twoSample = parseInt(cartDrawer.getAttribute('data-two-sample'), 10);
    const threeSample = parseInt(cartDrawer.getAttribute('data-three-sample'), 10);
    let freeItemCount = response.items.filter(item => item.product_type === 'Sample').length;
    let itemId = response.items.filter(item => item.product_type === 'Sample').map(item => item.id);

    if (response.total_price <= twoSample && twoSample) {
      if (freeItemCount >= 2) {
        removeSampleItem(itemId[0], 'cartdrawer');
      }
    } else if (response.total_price < threeSample && threeSample && freeItemCount === 3) {
      removeSampleItem(itemId[0], 'cartdrawer');
    }
  }

  if (response.total_price === 0 && response.item_count >= 1 && mainCart) {
    fetch('cart/clear.js').then(() => {
      setTimeout(() => {
        location.reload();
      }, 300);
    });
    return;
  }
  if (mainCart) {
    const twoSample = parseInt(mainCart.querySelector('cart-items').getAttribute('data-two-sample'), 10);
    const threeSample = parseInt(mainCart.querySelector('cart-items').getAttribute('data-three-sample'), 10);
    let freeItemCount = response.items.filter(item => item.product_type === 'Sample').length;
    let itemId = response.items.filter(item => item.product_type === 'Sample').map(item => item.id);

    if (response.total_price <= twoSample && twoSample) {
      if (freeItemCount >= 2) {
        removeSampleItem(itemId[0], 'maincart');
      }
    } else if (response.total_price < threeSample && threeSample && freeItemCount === 3) {
      removeSampleItem(itemId[0], 'maincart');
    }
  }
  if (mainCart && response.item_count === 0) {
    mainCart.classList.remove('main-cart');
    const elementsToRemove = ['.cart-slider', '.cart-drawer__offer', 'cart-items .c-accordion', '.cart-drawer__highlights', '.cart-count-bubble'];

    elementsToRemove.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) element.remove();
    });
  }

  function removeSampleItem(id, carttype) {
    let buttonType
     if(carttype == 'maincart'){
        buttonType = 'a';
     }
     else{
     buttonType = 'button';
     }
    const sampleRemoveButton = document.querySelector(`cart-remove-button[data-id="${id}"] ${buttonType}.event_remove_from_cart`);
    if (sampleRemoveButton) {
      sampleRemoveButton.click();
    }
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
